module.exports = "label {\n  font-weight: normal;\n  color: white;\n  display: block;\n  text-transform: capitalize; }\n\ndiv {\n  position: absolute;\n  background-color: white;\n  opacity: .8;\n  width: 155px;\n  border-radius: 0px 0px 5px 5px;\n  padding: 0px 10px; }\n\np {\n  margin: 2px; }\n\np:focus, p:hover {\n  margin: 2px;\n  background-color: white;\n  outline: none;\n  font-style: italic; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/auto-fill-2/auto-fill-2.component.scss
// module id = 1155
// module chunks = 1